// @flow

export const BIRTH_CERTIFICATE_RF = 'RussianBirthCertificate';
export const OFFICER_ID = 'RussianOfficerID';
export const NAVY_PASSPORT = 'RussianNavyPassport';
export const MILITARY_PASSPORT = 'RussianMilitaryPassport';
export const DIPLOMATIC_PASSPORT = 'RussianDiplomaticPassport';
export const FOREIGN_PASSPORT = 'ForeignPassport';
export const RESIDENCE_PERMIT = 'RussianResidencePermit';
export const REFUGEE_ID = 'RussianRefugeeID';
export const TEMPORARY_ID = 'RussianTemporaryID';
export const PASSPORT_RF = 'RussianPassport';
export const TRAVEL_PASSPORT = 'RussianTravelPassport';
export const BIRTH_CERTIFICATE_FOREIGN = 'ForeignBirthCertificate';
export const SEAMAN_PASSPORT = 'RussianSeamanPassport';

const KNOWN_IDENTITY_DOCS_TYPES_SERVER_CODES = {
	BIRTH_CERTIFICATE_RF,
	OFFICER_ID,
	NAVY_PASSPORT,
	MILITARY_PASSPORT,
	DIPLOMATIC_PASSPORT,
	FOREIGN_PASSPORT,
	RESIDENCE_PERMIT,
	REFUGEE_ID,
	TEMPORARY_ID,
	PASSPORT_RF,
	TRAVEL_PASSPORT,
	BIRTH_CERTIFICATE_FOREIGN,
	SEAMAN_PASSPORT,
};

export type KnownRestIdentityDocTypeEnum = $Values<typeof KNOWN_IDENTITY_DOCS_TYPES_SERVER_CODES>;
